var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',_vm._b({attrs:{"outlined":"","sort-compare":_vm.compare},on:{"sort-changed":_vm.changeSortType},scopedSlots:_vm._u([{key:"table-colgroup",fn:function(ref){
var fields = ref.fields;
return _vm._l((fields),function(f){return _c('col',{key:f.key,class:("col-" + (f.key))})})}},{key:"project",fn:function(ref){
var ref_value = ref.value;
var id = ref_value.id;
var name = ref_value.name;
var icon = ref_value.icon;
return [_c('img',{staticClass:"icon mr-1",attrs:{"src":icon,"alt":""}}),_c('b-link',{attrs:{"to":{ name: 'project-show', params: { projectId: id } }}},[_vm._v("\n      "+_vm._s(name)+"\n    ")])]}},{key:"client",fn:function(ref){
var ref_value = ref.value;
var company = ref_value.company;
var staff = ref_value.staff;
return [_c('div',[_vm._v(_vm._s(company))]),_c('small',[_vm._v(_vm._s(staff))])]}},{key:"status",fn:function(ref){
var value = ref.value;
return [_c('ProjectStatus',{attrs:{"variant":value,"size":"sm"}})]}},{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('ProjectListActions',{attrs:{"item":item},on:{"suspend":function($event){return _vm.$emit('suspend', $event)},"close":function($event){return _vm.$emit('close', $event)}}})]}}])},'b-table',{ fields: _vm.fields, items: _vm.items },false))}
var staticRenderFns = []

export { render, staticRenderFns }